<button axButton button-filled color="white" [hidden]="!source" (click)="preview()">
  <ax-image-source [source]="source">
    <ax-icon class="icon" name="image"></ax-icon>
  </ax-image-source>
</button>
